module.exports = __webpack_public_path__ + "img/ic-menu-open-white.9bdc6611.svg";